import React from "react";
import { Trophy } from "lucide-react";

// Weekly top-10 board shared by lesson games; `field` is the score key ("bars" or "score").
export const WeeklyBoard = ({ title, board, testId, user, field, unit, empty }) => (
  <div className="mt-4 rounded-xl border border-border bg-background/60 p-3" data-testid={`${testId}-board`}>
    <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-primary"><Trophy size={13} /> {title}</p>
    {board?.entries?.length ? (
      <ol className="mt-2 space-y-1 text-sm">
        {board.entries.map((e) => (
          <li key={e.rank} className={`flex justify-between rounded-lg px-2 py-1 ${e.is_me ? "bg-primary/15 font-semibold" : ""}`} data-testid={`${testId}-board-row-${e.rank}`}>
            <span>{e.rank}. {e.name}{e.is_me ? " (you)" : ""}</span><span className="font-mono">{unit(e[field])}</span>
          </li>
        ))}
      </ol>
    ) : <p className="mt-2 text-xs text-muted-foreground">No scores yet this week. Be the first!</p>}
    {board?.my_rank > 10 && <p className="mt-2 text-xs font-semibold" data-testid={`${testId}-board-me`}>You're #{board.my_rank} this week with {unit(board[`my_${field}`])}.</p>}
    {board && !board.my_rank && <p className="mt-2 text-[11px] text-muted-foreground">{user ? empty : "Sign in to get your name on the board."}</p>}
  </div>
);
